import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';

export const authRedirectGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.isLoggedIn()) {
    // If logged in, redirect to rdata-aggregates
    return router.createUrlTree(['/rdata-aggregates']);
  }

  // If not logged in, allow access to sign-in
  return true;
};
